import { useState, useEffect } from "react";
import { Ontology, Type } from "../annotation/ontology";
import InputDropdown from "./InputDropdown";
import { Entity } from "../model/entities";
import { Situation as SituationIntermediate } from "../structure/intermediates";
import { ToastType } from "../communication";

type DropdownType =
	| Ontology<Type>
	| string[]
	| Entity[]
	| SituationIntermediate[];

interface MetaItemProps {
	label: string;
	value: string;
	attribute: string;
	dropDown?: DropdownType;
	dropDownType?: "entity" | "situation" | "ontology" | "options";
	map: Map<string, string>;
	mutateReferent:
		| ((
				attribute: string,
				value: string,
				kind?: "entity" | "situation" | "options"
		  ) => void)
		| ((attribute: string, value: string) => void);
	roleValues?: JSX.Element;
	disabled: boolean;
	placeHolderEntity?: string;
	disabledMessageShow?: (message: string, type: ToastType) => void;
}

export default function MetaItem(
	props: MetaItemProps
) {
	const [value, setValue] = useState<string>(props.value);

	useEffect(() => {
		setValue(props.value);
	}, [props.value]);

	let field = null;
	if (props.dropDown !== undefined) {
		if (props.dropDownType === "entity") {
			field = (
				<InputDropdown
					attribute={props.attribute}
					dropDownType={"entity"}
					dropDownElements={props.dropDown as Entity[]}
					dropDownMap={props.map}
					mutateReferent={props.mutateReferent}
					value={props.value}
					disabled={props.disabled}
					placeHolder={props.placeHolderEntity}
				/>
			);
		} else if (props.dropDownType === "situation") {
			field = (
				<InputDropdown
					attribute={props.attribute}
					dropDownType={"situation"}
					dropDownElements={props.dropDown as SituationIntermediate[]}
					dropDownMap={props.map}
					mutateReferent={props.mutateReferent}
					value={props.value}
					disabled={props.disabled}
				/>
			);
		} else if (props.dropDownType === "ontology") {
			field = (
				<InputDropdown
					attribute={props.attribute}
					dropDownType={"ontology"}
					dropDownElements={props.dropDown as Ontology<Type>}
					mutateReferent={props.mutateReferent}
					value={props.value}
					disabled={props.disabled}
				/>
			);
		} else if (props.dropDownType === "options") {
			field = (
				<InputDropdown
					attribute={props.attribute}
					dropDownType={"options"}
					dropDownElements={props.dropDown as string[]}
					mutateReferent={props.mutateReferent}
					value={props.value}
					disabled={props.disabled}
				/>
			);
		}
	} else {
		field = (
			<input
				className="meta-item-input"
				value={value}
				onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
					e.preventDefault();
					setValue(e.target.value);
				}}
				onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
					e.stopPropagation();
					if (e.key === "Enter" && value) {
						e.preventDefault();
						(e.target as HTMLTextAreaElement).blur();
						props.mutateReferent(props.attribute, value, "options");
					}
				}}
				onBlur={() => {
					if (value) {
						props.mutateReferent(props.attribute, value, "options");
					} else {
						setValue(props.value);
					}
				}}
				disabled={props.disabled}
			/>
		);
	}

	return (
		<div
			className="meta-item"
			onClick={() => {
				if (props.disabled && props.disabledMessageShow) {
					props.disabledMessageShow(
						"Please clear Entity as role-fillers to change its Type",
						"info"
					);
				}
			}}>
			<p>{props.label}:</p>
			<div className="meta-values">
				{props.roleValues}
				{field}
			</div>
		</div>
	);
}
